import { useState, useEffect } from 'react';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';
const BAKED_VERSION = process.env.REACT_APP_APP_VERSION || 'Development';

// plan 2189: the running version is a deploy-time value served by /api/health, not the label baked into the SPA image.
// The baked value is only the fallback while the fetch is in flight or if it fails. /health answers 503 with the same
// body when MySQL or Redis is down, so the body is read regardless of status.
let cachedPromise = null;

export function resetBuildInfoCache() { cachedPromise = null; }

function fetchBuildInfo() {
  if (!cachedPromise) {
    cachedPromise = fetch(`${API_BASE_URL}/health`, { credentials: 'include' })
      .then((r) => r.json())
      .then((data) => {
        if (data && typeof data.version === 'string') return data;
        cachedPromise = null;
        return null;
      })
      .catch(() => { cachedPromise = null; return null; });
  }
  return cachedPromise;
}

export function formatBuildInfo(info, settled = true) {
  if (!info && !settled) return '';
  const version = (info && info.version) || BAKED_VERSION;
  const parts = [version];
  if (info && info.environment && info.environment !== 'unknown') parts.push(info.environment);
  if (info && info.commit) parts.push(info.commit);
  return parts.join(' · ');
}

export default function useBuildInfo() {
  const [info, setInfo] = useState(null);
  const [settled, setSettled] = useState(false);
  useEffect(() => {
    let cancelled = false;
    fetchBuildInfo().then((data) => {
      if (cancelled) return;
      setInfo(data);
      setSettled(true);
    });
    return () => { cancelled = true; };
  }, []);
  // Blank until the first answer so a prod page does not flash the baked fallback ("Development") before /health replies.
  return { info, label: formatBuildInfo(info, settled) };
}
